import { get } from '../../utils/http';

export const fetchAvailableEmployeesByTimeAndPosition = ({
  accountId,
  branchId,
  startTime,
  endTime,
  positionId,
  name,
  pageSize,
  token,
  onlyActiveEmployees,
  shiftId,
  projectId
}) =>
  get(`/accounts/${accountId}/branches/${branchId}/availability`, {
    startTime,
    endTime,
    positionId,
    name,
    pageSize,
    page: token || 0,
    kinds: ['available', 'other', 'applied-rejection', 'available-rejection'],
    warnings: true,
    info: false,
    ...(shiftId && { shiftId }),
    ...(projectId && { projectId }),
    onlyActiveEmployees
  });

export const fetchAvailableEmployeesByDate = ({ accountId, branchId, date }) =>
  get(`/accounts/${accountId}/branches/${branchId}/availability/date`, {
    date
  });
